import './App.css';
import Header from './components/Header';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Certificates from './components/Certificates';
import Contact from './components/Contact';
import Footer from './components/Footer';
//import StarsCanvas from './components/Stars';

function App() {
  return (
    <div className="App">
      {/*<StarsCanvas /> */}
      <Header />
      <main className="container">
          <About />
          <Skills />
          <Experience />
          <Projects />
          <Certificates />
          <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
